// import React, { useEffect, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import {
//   FaBell,
//   FaCog,
//   FaSearch,
//   FaUser,
//   FaComments,
//   FaHome,
//   FaNewspaper,
// } from 'react-icons/fa';
// import styles from './Header.module.css';
// import SearchModal from './SearchModal';
// import Logo from './Logo';
// import ChatUnreadBadge from './chat/ChatUnreadBadge';
// import PostNotificationBadge from './PostNotificationBadge';
// import NotificationDropdown from './notifications/NotificationDropdown';
// import CreatePostModal from './createPost';
// import { useGetProfileQuery } from '../store/api/profileApi';
// import { Link } from "react-router-dom";

// export default function Header() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [searchOpen, setSearchOpen] = useState(false);
//   const [notificationOpen, setNotificationOpen] = useState(false);
//   const [createPostOpen, setCreatePostOpen] = useState(false);   // ✅ new

//   const { data: user } = useGetProfileQuery();                   // ✅ new

//   const [activeTab, setActiveTab] = useState(location.pathname);

//   const handleTabClick = (path) => {
//     setActiveTab(path);
//     navigate(path);
//   };

//   const handleLogoClick = () => {
//   if (location.pathname === "/home") {
//     window.location.reload();
//   } else {
//     navigate("/home");
//   }
// };

//   useEffect(() => {
//     const close = (e) => {
//       if (!e.target.closest(`.${styles.iconWrapper}`)) {
//         setNotificationOpen(false);
//       }
//     };
//     document.addEventListener('click', close);
//     return () => document.removeEventListener('click', close);
//   }, []);

//   return (
//     <>
//       <header className={styles.header}>
//         <div className={styles.leftSection}>
//         <div
//   onClick={handleLogoClick}
//   className={styles.logoClickable}
//   style={{ marginRight: "14px" }}
// >
//   <Logo height={50} />
// </div>

//           <div className={styles.searchBox} onClick={() => setSearchOpen(true)}>
//             <FaSearch className={styles.searchIcon} />
//             <input type="text" placeholder="Search people..." readOnly />
//           </div>
//         </div>

//         <nav className={styles.nav}>
//           <button
//             className={activeTab === '/home' ? styles.active : ''}
//             onClick={() => handleTabClick('/home')}
//           >
//             <FaHome /> <span>Feed</span>
//           </button>

//           <button
//             className={activeTab === '/news' ? styles.active : ''}
//             onClick={() => handleTabClick('/news')}
//           >
//             <FaNewspaper /> <span>News</span>
//           </button>

//           <button
//             className={activeTab === '/profile' ? styles.active : ''}
//             onClick={() => handleTabClick('/profile')}
//           >
//             <FaUser /> <span>Profile</span>
//           </button>

//           <button
//             className={activeTab === '/chat' ? styles.active : ''}
//             onClick={() => handleTabClick('/chat')}
//           >
//             <FaComments /> <span>Chat</span><ChatUnreadBadge />
//           </button>

//           {/* <button
//             className={activeTab === '/settings' ? styles.active : ''}
//             onClick={() => handleTabClick('/settings')}
//           >
//             <FaCog /> <span>Settings</span>
//           </button> */}
//         </nav>

//         <div className={styles.right}>
//           <div
//             className={styles.iconWrapper}
//             onClick={() => handleTabClick('/settings')}
//           >
//             <FaCog className={styles.icon}/>
//           </div>

//           <div
//             className={styles.iconWrapper}
//             onClick={() => setNotificationOpen((prev) => !prev)}
//           >
//             <FaBell className={styles.icon} />
//             <PostNotificationBadge />
//             {notificationOpen && <NotificationDropdown />}
//           </div>
//         </div>
//       </header>

//       <SearchModal isOpen={searchOpen} onClose={() => setSearchOpen(false)} />

//       {/* ✅ Single shared CreatePostModal for mobile nav */}
//       <CreatePostModal
//         isOpen={createPostOpen}
//         onClose={() => setCreatePostOpen(false)}
//         userPhoto={user?.profilePhotoUrl}
//         userName={user?.name || 'User'}
//         onPostCreated={() => setCreatePostOpen(false)}
//       />

//       {/* Bottom Navigation for Mobile */}
//       <div className={styles.mobileNav}>
//         <button
//           className={activeTab === '/home' ? styles.active : ''}
//           onClick={() => handleTabClick('/home')}
//         >
//           <FaHome />
//         </button>

//         <button
//           className={activeTab === '/news' ? styles.active : ''}
//           onClick={() => handleTabClick('/news')}
//         >
//           <FaNewspaper />
//         </button>

//         {/* ✅ Opens modal instead of navigating */}
//         <button
//           className={styles.createBtn}
//           onClick={() => setCreatePostOpen(true)}
//         >
//           +
//         </button>

//         <button
//           className={activeTab === '/chat' ? styles.active : ''}
//           onClick={() => handleTabClick('/chat')}
//         >
//           <FaComments />
//           <ChatUnreadBadge />
//         </button>

//         <button
//           className={activeTab === '/profile' ? styles.active : ''}
//           onClick={() => handleTabClick('/profile')}
//         >
//           <FaUser />
//         </button>
//       </div>
//     </>
//   );
// }

import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaBell,
  FaCog,
  FaSearch,
  FaUser,
  FaComments,
  FaHome,
  FaNewspaper,
} from 'react-icons/fa';
import styles from './Header.module.css';
import SearchModal from './SearchModal';
import Logo from './Logo';
import ChatUnreadBadge from './chat/ChatUnreadBadge';
import PostNotificationBadge from './PostNotificationBadge';
import NotificationDropdown from './notifications/NotificationDropdown';
import CreatePostModal from './createPost';
import { useGetProfileQuery } from '../store/api/profileApi';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchOpen, setSearchOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [createPostOpen, setCreatePostOpen] = useState(false);   // ✅ new

  const { data: user } = useGetProfileQuery();                   // ✅ new
  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated ?? false);

  const [activeTab, setActiveTab] = useState(location.pathname);

  const handleTabClick = (path) => {
    setActiveTab(path);
    navigate(path);
  };

  const handleLogoClick = () => {
  if (location.pathname === "/home") {
    window.location.reload();
  } else {
    navigate("/home");
  }
};

  useEffect(() => {
    const close = (e) => {
      if (!e.target.closest(`.${styles.iconWrapper}`)) {
        setNotificationOpen(false);
      }
    };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  // Logo-only header for unauthenticated users (public post view)
  if (!isAuthenticated) {
    return (
      <header className={styles.header} style={{ justifyContent: 'center' }}>
        <div className={styles.logoClickable} onClick={() => navigate('/')}>
          <Logo height={50} />
        </div>
      </header>
    );
  }

  return (
    <>
      <header className={styles.header}>
        <div className={styles.leftSection}>
        <div
  onClick={handleLogoClick}
  className={styles.logoClickable}
  style={{ marginRight: "14px" }}
>
  <Logo height={50} />
</div>

          <div className={styles.searchBox} onClick={() => setSearchOpen(true)}>
            <FaSearch className={styles.searchIcon} />
            <input type="text" placeholder="Search people..." readOnly />
          </div>
        </div>

        <nav className={styles.nav}>
          <button
            className={activeTab === '/home' ? styles.active : ''}
            onClick={() => handleTabClick('/home')}
          >
            <FaHome /> <span>Feed</span>
          </button>

          <button
            className={activeTab === '/news' ? styles.active : ''}
            onClick={() => handleTabClick('/news')}
          >
            <FaNewspaper /> <span>News</span>
          </button>

          <button
            className={activeTab === '/profile' ? styles.active : ''}
            onClick={() => handleTabClick('/profile')}
          >
            <FaUser /> <span>Profile</span>
          </button>

          <button
            className={activeTab === '/chat' ? styles.active : ''}
            onClick={() => handleTabClick('/chat')}
          >
            <FaComments /> <span>Chat</span><ChatUnreadBadge />
          </button>

          {/* <button
            className={activeTab === '/settings' ? styles.active : ''}
            onClick={() => handleTabClick('/settings')}
          >
            <FaCog /> <span>Settings</span>
          </button> */}
        </nav>

        <div className={styles.right}>
          <div
            className={styles.iconWrapper}
            onClick={() => handleTabClick('/settings')}
          >
            <FaCog className={styles.icon}/>
          </div>

          <div
            className={styles.iconWrapper}
            onClick={() => setNotificationOpen((prev) => !prev)}
          >
            <FaBell className={styles.icon} />
            <PostNotificationBadge />
            {notificationOpen && <NotificationDropdown />}
          </div>
        </div>
      </header>

      <SearchModal isOpen={searchOpen} onClose={() => setSearchOpen(false)} />

      {/* ✅ Single shared CreatePostModal for mobile nav */}
      <CreatePostModal
        isOpen={createPostOpen}
        onClose={() => setCreatePostOpen(false)}
        userPhoto={user?.profilePhotoUrl}
        userName={user?.name || 'User'}
        onPostCreated={() => setCreatePostOpen(false)}
      />

      {/* Bottom Navigation for Mobile */}
      <div className={styles.mobileNav}>
        <button
          className={activeTab === '/home' ? styles.active : ''}
          onClick={() => handleTabClick('/home')}
        >
          <FaHome />
        </button>

        <button
          className={activeTab === '/news' ? styles.active : ''}
          onClick={() => handleTabClick('/news')}
        >
          <FaNewspaper />
        </button>

        {/* ✅ Opens modal instead of navigating */}
        <button
          className={styles.createBtn}
          onClick={() => setCreatePostOpen(true)}
        >
          +
        </button>

        <button
          className={activeTab === '/chat' ? styles.active : ''}
          onClick={() => handleTabClick('/chat')}
        >
          <FaComments />
          <ChatUnreadBadge />
        </button>

        <button
          className={activeTab === '/profile' ? styles.active : ''}
          onClick={() => handleTabClick('/profile')}
        >
          <FaUser />
        </button>
      </div>
    </>
  );
}